import React, { useState, useEffect } from 'react';
import { calculateTimeDifference, formatNumber } from '../utils/dateCalculations';

const CollapsibleDateCounter = ({ startDate }) => {
  const [timeDiff, setTimeDiff] = useState(calculateTimeDifference(startDate, new Date()));
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDiff(calculateTimeDifference(startDate, new Date()));
    }, 1000);

    return () => clearInterval(interval);
  }, [startDate]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-counter ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <img src="/images/flower-frame.png" className="flower-frame-top" alt="" />
      <img src="/images/flower-frame.png" className="flower-frame-bottom" alt="" />
      
      <div className="counter-header-fixed">
        <div className="counter-toggle" onClick={toggleExpanded}>
          <div className="counter-summary">
            <span className="summary-number">{timeDiff.years}</span>
            <span className="summary-label">Years</span>
            <span className="summary-number">{timeDiff.months}</span>
            <span className="summary-label">Months</span>
          </div>
          <button className="toggle-btn">
            {isExpanded ? '✕' : '⋯'}
          </button>
        </div>
      </div>

      <div className="counter-details">
        <div className="counter-header">
          <h2>Our Journey Together</h2>
          <p className="start-date">Since July 22, 2018</p>
        </div>
        
        <div className="time-display">
          <div className="time-unit">
            <span className="number">{timeDiff.years}</span>
            <span className="label">Years</span>
          </div>
          <div className="time-unit">
            <span className="number">{timeDiff.months}</span>
            <span className="label">Months</span>
          </div>
          <div className="time-unit">
            <span className="number">{timeDiff.days}</span>
            <span className="label">Days</span>
          </div>
        </div>
        
        <div className="milestone-stats">
          <div className="stat">
            <span className="stat-number">{formatNumber(timeDiff.totalDays)}</span>
            <span className="stat-label">Total Days</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollapsibleDateCounter;